import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { requester } from "App.js";
import { useEffect, useState } from "react";
import style from "./AllProductList.module.css";
import Container from "layouts/container/Container";

function AllProductList({ storeId }) {
    
    const [storeProduct, setStoreProduct] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);

    const [activeTab, setActiveTab] = useState(false)

    useEffect(() => {
        let data = { storeId };
        requester.findAllByStoreIdWithCategory(data, (result) => {
            setStoreProduct(result.data);
        });
    }, [storeId]);

    const filterProducts = (categories, exclude = false) => {
        if (exclude) {
            return storeProduct?.filter(product =>
                !categories.includes(product.categoryName)
            ).slice(0, 4);
        } else {
            return storeProduct?.filter(product =>
                categories.includes(product.categoryName)
            ).slice(0, 4);
        }
    };

    const handleCategoryClick = (categoryName) => {
        
        setSelectedCategory(categoryName);
        setActiveTab(true);
    };
    // const Card = (props) => {

    //     const { img, brand, productName, id } = props;
    //     const onClick = () => {
    //         navigate(`/product/detail/${props.id}`);
    //     }

    //     return (
    //         <div onClick={onClick} style={{ display: "flex", flex: "0 1 20%" }}>
    //             <VerticalFlex flexStart>
    //                 <FlexChild>
    //                     <img src={img && img} width={"100%"} style={{ cursor: "pointer", borderRadius: "20px" }} />
    //                 </FlexChild>
    //                 <FlexChild>
    //                     <Center width={"90%"} >
    //                         <P ellipsis cursor weight={"bold"} size={"12pt"}>{brand && brand}</P>
    //                         <P ellipsis cursor size={"12pt"}>{productName && productName}</P>
    //                     </Center>
    //                 </FlexChild>
    //             </VerticalFlex>
    //         </div>
    //     );
    // }

    const renderProductList = (categories, title, exclude = false) => {
        const filteredProducts = filterProducts(categories, exclude);
        return (
            <>
                <FlexChild>
                    <HorizontalFlex>
                        <FlexChild>
                            <P size={30} weight={500}>{title}</P>
                        </FlexChild>
                        <FlexChild>
                            <P cursor={"pointer"} onClick={() => handleCategoryClick(title)}>전체보기</P>
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>
                <FlexChild>
                    <HorizontalFlex>
                        <FlexChild>
                            <div className={style.allProductList}>
                                {filteredProducts?.map((product, index) => (
                                    <div key={index} style={{ flex: "1 1 50%" }}>
                                        <div style={{ width: "100%", height: "100%", position: "relative" }}>
                                            <img
                                                src={product.productImg}
                                                style={{ width: "80%", height: "80%" }}
                                            />
                                            <P weight={"bold"} size={15}>{product.productName}</P>
                                            <P weight={"bold"} size={15}>{product.price.toLocaleString()}원</P>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>
            </>
        );
    };

    return (
        <div>
            <Container>
                <VerticalFlex gap={30}>
                    {renderProductList(["전자담배기기"], "기기")}
                    {renderProductList(["일회용기기", "일회용"], "일회용")}
                    {renderProductList(
                        ["일회용기기", "일회용", "전자담배기기"],
                        "기성",
                        true
                    )}
                    {renderProductList(
                        ["일회용기기", "일회용", "전자담배기기"],
                        "모드",
                        true
                    )}
                </VerticalFlex>
            </Container>
        </div>
    );
}

export default AllProductList;
